// 앱 저장소 시각 표시 — i18n 을 부르지 않는 따로 된 모듈이다(formatters 는 i18n 초기화를 불러, react-i18next 를 흉내 내는 시험에서 깨졌다)
/**
 * 앱 저장소(SQLite)의 시각 — `datetime('now')` 는 **UTC** 를 시간대 없이(`YYYY-MM-DD HH:MM:SS`) 적는다(2026-10-22).
 * 그 글을 그대로 찍거나 new Date() 로 읽으면 현지 시각으로 해석되어 한국에서 9시간 이르게 보였다(로그 시각 — 신고).
 * 시간대가 없는 글은 UTC 로 읽고, 'Z'·오프셋이 있는 글·Date·숫자는 그대로 읽는다.
 * **Oracle DB 의 시각(DB 서버 벽시계 — 시간대 없는 글)에는 쓰지 말 것** — 그것은 formatDateTime 이 현지 시각으로 읽는 것이 맞다.
 */
const NAIVE_TS = /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)$/;
export function parseStoredTime(value) {
    if (value == null || value === '') return null;
    if (value instanceof Date) return value;
    if (typeof value === 'number') return new Date(value);
    const s = String(value).trim();
    const m = NAIVE_TS.exec(s);
    const d = new Date(m ? `${m[1]}T${m[2]}Z` : s);
    return Number.isNaN(d.getTime()) ? null : d;
}
/**
 * 앱 저장소 시각(SQLite UTC 글 · ISO)을 **현지 시각**의 `YYYY-MM-DD HH:MM:SS` 모양으로 — 예전에 글을 잘라 보이던 화면들과 같은 모양이다.
 * fmt: 'sec'(기본, 초까지) · 'min'(분까지) · 'date'(날짜만) · 'time'(시각만) · 'short'(MM-DD HH:MM). 비었으면 '', 읽지 못하면 받은 글 그대로
 */
const pad2 = (n) => String(n).padStart(2, '0');
export function storedTime(value, fmt = 'sec') {
    if (value == null || value === '') return '';
    const d = parseStoredTime(value);
    if (!d) return String(value);
    const date = `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
    const hm = `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
    const sec = `${hm}:${pad2(d.getSeconds())}`;
    if (fmt === 'date') return date;
    if (fmt === 'time') return sec;
    if (fmt === 'min') return `${date} ${hm}`;
    if (fmt === 'short') return `${date.slice(5)} ${hm}`;
    return `${date} ${sec}`;
}
/** storedTime 의 초까지 모양 — 비었으면 대시 */
export function formatStoredTime(value, { dash = '-' } = {}) {
    return value == null || value === '' ? dash : storedTime(value, 'sec');
}
